import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
  ...v2Day1SharedNPCs,
  {
    x: 2150,
    y: 1450,
    name: 'Bunga',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    repeatable: true, // Day Keeper should have repeatable dialogs
    dialogTree: {
      startDialogId: 'bunga_part2_1',
      nodes: {
        bunga_part2_1: {
          id: 'bunga_part2_1',
          speaker: 'Bunga',
          text: `Aku akan mencari Diana, selagi itu sebaiknya kamu menyiapkan sesuatu untuk Diana!`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "bunga_day1_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 3920,
    y: 900,
    name: 'Diana',
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'cutscene_1',
      nodes: {
        cutscene_1: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Sudah lama aku tidak kesini`,
          backgroundImage: '/assets/cutscene/diana_pray.ktx2',
          nextDialogId : "cutscene_2",
        },
        cutscene_2: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Hari ini aku berulang tahun yang ke 17.`,
          backgroundImage: '/assets/cutscene/diana_pray.ktx2',
          nextDialogId : "cutscene_3",
        },
        cutscene_3: {
          id: 'diana1',
          speaker: 'Diana',
          text: `Walaupun ibu mati saat kecil, aku tetap sangan rindu.`,
          backgroundImage: '/assets/cutscene/diana_pray.ktx2',
          nextDialogId : "cutscene_4",
        },
        cutscene_4: {
          id: 'diana1',
          speaker: 'Diana',
          fade : true,
          text: `Semoga ibu merasa kedamaian.`,
          backgroundImage: '/assets/cutscene/diana_pray.ktx2',
          nextDialogId : "diana1",
        },
        diana1: {
          id: 'diana1',
          speaker: 'Diana',
          fade : true,
          characterImage: '/assets/character/v2/diana.png',
          text: `Selamat pagi kak. Aku baru saja mengunjungi Ibu.`,
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "diana2",
        },
        diana2: {
          id: 'diana2',
          text : "",
          speaker: '',
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan2",
          choices: [
            {
              text: 'Aku juga ingin mengunjungi makam ibu.',
              nextDialogId : "diana3a",
            },
            {
              text: 'Ide bagus, aku juga disini untuk mencari ibu.',
              nextDialogId : "diana3a",
            },
          ],
        },
        diana3a: {
          id: 'diana3a',
          speaker: 'Diana',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          characterImage: '/assets/character/v2/diana.png',
          text: `Aku akan berikan kak Yan waktu sendiri dengan ibu..`,
          nextDialogId : "diana4a",
        },
        diana4a: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana_h.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          text: `Ngomong-ngomong, apakah kak Yan melihat Elsa?`,
          nextDialogId : "diana5",
        },
        diana5: {
          id: 'diana5',
          text : "",
          speaker: '',
          characterImage: '/assets/character/v2/diana_h.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          choices: [
            {
              text: 'Oh, aku kira Elsa bersama kamu?',
              nextDialogId : "diana6",
            },
            {
              text: 'Tidak, pagi-pagi sudah tidak ada Elsa di kamar.',
              nextDialogId : "diana6",
            },
          ],
        },
        diana6: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana_h.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          text: `Tidak, aku belum melihat Elsa dari pagi. Mungkin dia tersesat di Danau.`,
          nextDialogId : "diana7",
        },
        diana7: {
          id: 'diana4a',
          speaker: 'Diana',
          characterImage: '/assets/character/v2/diana_h.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          text: `Kalau begitu aku akan ke Danau mencari Elsa.`,
          nextDialogId : "diana8",
        },
        diana8: {
          id: 'diana8',
          text : "",
          speaker: '',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          characterImage: '/assets/character/v2/diana_h.png',
          choices: [
            {
              text: 'Baiklah, hati-hati ya.',
              nextDialogId : "part3_opening0",
            },
            {
              text: 'Ok, sampai jumpa!',
              nextDialogId : "part3_opening0",
            },
          ],
        },
        part3_opening0: {
          id: 'part3_opening0',
          speaker: 'Yan',
          text: `Sebaiknya selagi disini kita mengunjungi makam ibu.`,
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          storyAction: { type: 'nextDay', value: 0 },
          isEnd : true
        },
      },
    },
  },

];

export default config;
